<div class="container-body">
  <img class="login-image" src="assets/images/login-image.png" />
  <div class="vertical-aling-out">

    <div class="vertical-aling-inner">
      <div class="white-box">
        <div class="login-logo-image">
          <img src="assets/images/login-logo-image.png" />
        </div>
        @if (!this.isAutomaticLogin) {
          <h2>Acessar conta</h2>
        }
        @if (!this.isAutomaticLogin) {
          <form class="form" [formGroup]="model" (ngSubmit)="signin()">
            @if (state) {
              <div class="row">
                <div class="col-md-12">
                  <mat-form-field appearance="outline">
                    <mat-label>Matrícula ou CPF</mat-label>
                    <input matInput type="text" autofocus formControlName="login" required
                      (keydown.enter)="checkLogin()">
                      @if (model.get('login').invalid) {
                        <mat-error>Informe a Matricula</mat-error>
                      }
                    </mat-form-field>
                  </div>
                </div>
              }
              @if (!state) {
                <app-verify-auth [formGroup]="model" [listHealthUnit]="listHealthUnit" [isLoading]="isLoading || isLoadingLogin"
                  [canStayConnected]="canStayConnected" [login]="model.get('login').value"
                  (goBack)="changeState($event)" (forgotPasswordAuth)="forgotPassword()"
                (setCanStayConnected)="setCanStayConnected($event)"></app-verify-auth>
              }
              <div class="row">
                @if (!listHealthUnit) {
                  <div class="col-md-12 align-button">
                    <div class="split-button">
                      <button mat-flat-button color="primary" type="button" class="btn btn-primary btn-sm"
                        (click)="checkLogin()">
                        @if (isLoading == false && !isLoadingLogin) {
                          <span>Login</span>
                        }
                        @if (isLoading == true || isLoadingLogin) {
                          <mat-spinner [diameter]="30" class="mat-spinner-btn"
                          ></mat-spinner>
                        }
                      </button>
                    </div>
                    <div class="split-button">
                      <button mat-flat-button type="button" (click)="forgotPassword()" color="accent"
                        class="btn btn-outline-primary btn-sm">
                        Esqueci minha senha
                      </button>
                    </div>
                  </div>
                }
                <div class="col-12">
                  <div class="separator"></div>
                </div>
                <div class="col-12" id="googleButtonDiv"></div>
                <div class="col-12">
                  <button mat-flat-button type="button" class="microsoft-login-btn btn" (click)="msalLogin()">
                    <img class="login-icon" src="assets/icons/microsoft.png" aria-hidden="false"
                      aria-label="sound" />
                      <span>Entrar com a conta Office 365</span>
                    </button>
                  </div>
                </div>
              </form>
            }
            @if (this.isAutomaticLogin && this.automaticLoginLoading) {
              <div class="automatic-login">
                <div>
                  <h1>Bem vindo(a), {{this.stayConnected.name}}!</h1>
                </div>
                <div>
                  <p>Estamos te redirecionando para a {{this.stayConnected.healthUnit}}...</p>
                </div>
                <div class="snippet" data-title="dot-pulse">
                  <div class="stage">
                    <div class="dot-pulse"></div>
                  </div>
                </div>
              </div>
            }
            @if (this.isAutomaticLogin && !this.automaticLoginLoading) {
              <div class="automatic-login">
                <div>
                  <h2>Não foi possível fazer o Login Automático</h2>
                </div>
                <button mat-flat-button color="primary" type="button" class="btn btn-primary btn-sm col-12"
                  (click)="getAutomaticLoginByGuid()">
                  @if (isLoading == false) {
                    <span>Tentar novamente</span>
                  }
                  @if (isLoading == true) {
                    <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                  }
                </button>
                <button mat-flat-button color="accent" type="button" class="btn btn-primary btn-sm col-12"
                  (click)="returnLoginScreen()">
                  @if (isLoading == false) {
                    <span>Entrar com usuário e senha</span>
                  }
                  @if (isLoading == true) {
                    <mat-spinner [diameter]="30" class="mat-spinner-btn"></mat-spinner>
                  }
                </button>
              </div>
            }
          </div>
        </div>
      </div>
    </div>